export default () => ({
  compilerOptions: {
    moduleResolution: 'nodenext',
    target: 'ES2021',
    checkJs: true,
    allowJs: true,
  },
});
